import { createSlice, Middleware } from "@reduxjs/toolkit"
import { IFocusInput } from "./types"

type initialState = {
  response: IFocusInput | null
}

export const focusInputSlice = createSlice({
  name: "focusInput",
  initialState: { response: null } as initialState,
  reducers: {
    setIsfocusInput(state, action) {
      state.response = action.payload
    }
  }
})

export const { setIsfocusInput } = focusInputSlice.actions
export default focusInputSlice.reducer

export const focusInputHandlerMiddleware: Middleware = () => (next) => (action) => {
  return next(action)
}
